import leaflet from 'leaflet';

// Leaflet
const location = JSON.parse(document.querySelector('.acf-map').dataset.location);
const bounds = [];
// Save map bounds
bounds.push([location.lat, location.lng]);

const map = leaflet
  .map('map', { zoomControl: false })
  .fitBounds(bounds)
  .setZoom(location.zoom);

new leaflet.Control.Zoom({ position: 'bottomright' }).addTo(map);

leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
}).addTo(map);

const icon = leaflet.icon({
  iconUrl: map_assets.icon,
  iconSize: [67, 41]
});

leaflet
  .marker([location.lat, location.lng], { icon })
  .addTo(map);